import { render, staticRenderFns } from "./ks-device-manage.vue?vue&type=template&id=21d38ccc&scoped=true&"
import script from "./ks-device-manage.vue?vue&type=script&lang=js&"
export * from "./ks-device-manage.vue?vue&type=script&lang=js&"
import style0 from "./ks-device-manage.vue?vue&type=style&index=0&id=21d38ccc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d38ccc",
  null
  
)

export default component.exports